
// import React, { useEffect, useState } from 'react';
// import {
//   Table, TableBody, TableCell, TableHead, TableRow,
//   Paper, Select, MenuItem, Typography, Box, CircularProgress,
//   Snackbar, Alert, Switch, FormControlLabel, IconButton,
//   Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import {
//   getAllUsers,
//   updateUserRole,
//   updateUserBlockStatus,
//   deleteUser,                                      // ✅ new import
// } from '../../services/api';

// const ManageRoles = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // ✅ Delete dialog state
//   const [deleteDialog, setDeleteDialog] = useState({ open: false, user: null });
//   const [deleting, setDeleting] = useState(false);

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const res = await getAllUsers();
//       setUsers(res.data);
//     } catch (error) {
//       setSnackbar({ open: true, message: 'Failed to fetch users', severity: 'error' });
//     }
//     setLoading(false);
//   };

//   const handleRoleChange = async (email, newRole) => {
//     try {
//       await updateUserRole(email, newRole);
//       setUsers((prev) =>
//         prev.map((user) =>
//           user.userEmail === email ? { ...user, userRole: newRole } : user
//         )
//       );
//       setSnackbar({ open: true, message: 'Role updated', severity: 'success' });
//     } catch (error) {
//       setSnackbar({ open: true, message: 'Failed to update role', severity: 'error' });
//     }
//   };

//   const handleBlockToggle = async (email, currentlyBlocked) => {
//     const newStatus = !currentlyBlocked;
//     try {
//       await updateUserBlockStatus(email, newStatus);
//       setUsers((prev) =>
//         prev.map((user) =>
//           user.userEmail === email ? { ...user, isBlocked: newStatus } : user
//         )
//       );
//       setSnackbar({
//         open: true,
//         message: newStatus ? 'User blocked' : 'User unblocked',
//         severity: 'success',
//       });
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: 'Failed to update block status',
//         severity: 'error',
//       });
//     }
//   };

//   // ✅ Open the confirmation dialog
//   const openDeleteDialog = (user) => {
//     setDeleteDialog({ open: true, user });
//   };

//   // ✅ Close the confirmation dialog
//   const closeDeleteDialog = () => {
//     if (!deleting) setDeleteDialog({ open: false, user: null });
//   };

//   // ✅ Confirmed delete action
//   const handleConfirmDelete = async () => {
//     const user = deleteDialog.user;
//     if (!user) return;

//     setDeleting(true);
//     try {
//       await deleteUser(user.userId);
//       setUsers((prev) => prev.filter((u) => u.userId !== user.userId));
//       setSnackbar({
//         open: true,
//         message: `User "${user.userName}" deleted successfully`,
//         severity: 'success',
//       });
//       setDeleteDialog({ open: false, user: null });
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || 'Failed to delete user',
//         severity: 'error',
//       });
//     } finally {
//       setDeleting(false);
//     }
//   };

//   return (
//     <Box>
//       <Typography variant="h5" gutterBottom>
//         Manage Users
//       </Typography>
//       {loading ? (
//         <CircularProgress />
//       ) : (
//         <Paper>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>User ID</TableCell>
//                 <TableCell>Name</TableCell>
//                 <TableCell>Email</TableCell>
//                 <TableCell>Role</TableCell>
//                 <TableCell>Status</TableCell>
//                 <TableCell align="center">Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {users.map((user) => (
//                 <TableRow key={user.userId}>
//                   <TableCell>{user.userId}</TableCell>
//                   <TableCell>{user.userName}</TableCell>
//                   <TableCell>{user.userEmail}</TableCell>
//                   <TableCell>
//                     <Select
//                       value={user.userRole}
//                       onChange={(e) => handleRoleChange(user.userEmail, e.target.value)}
//                       disabled={user.isBlocked}
//                     >
//                       <MenuItem value="User">User</MenuItem>
//                       <MenuItem value="Admin">Admin</MenuItem>
//                     </Select>
//                   </TableCell>
//                   <TableCell>
//                     <FormControlLabel
//                       control={
//                         <Switch
//                           checked={!!user.isBlocked}
//                           onChange={() => handleBlockToggle(user.userEmail, !!user.isBlocked)}
//                           color="error"
//                         />
//                       }
//                       label={user.isBlocked ? 'Blocked' : 'Active'}
//                     />
//                   </TableCell>
//                   <TableCell align="center">
//                     <IconButton
//                       color="error"
//                       onClick={() => openDeleteDialog(user)}
//                       title="Delete user"
//                     >
//                       <DeleteIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}

//       {/* ✅ Delete confirmation dialog */}
//       <Dialog open={deleteDialog.open} onClose={closeDeleteDialog}>
//         <DialogTitle>Delete User?</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete <strong>{deleteDialog.user?.userName}</strong>{' '}
//             ({deleteDialog.user?.userEmail})?
//             <br /><br />
//             This will permanently remove the user and all their bookings.
//             This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeDeleteDialog} disabled={deleting}>
//             Cancel
//           </Button>
//           <Button onClick={handleConfirmDelete} color="error" disabled={deleting}>
//             {deleting ? 'Deleting...' : 'Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ManageRoles;



import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow,
  Paper, Select, MenuItem, Typography, Box, CircularProgress,
  Snackbar, Alert, Switch, FormControlLabel, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  DialogContentText, Tooltip, Divider, Stack,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import TuneIcon from '@mui/icons-material/Tune';
import {
  getAllUsers,
  updateUserRole,
  updateUserBlockStatus,
  deleteUser,
  getUserFeatures,
  updateUserFeature,
} from '../../services/api';

const FEATURES = [
  { key: 'SUGAR_LOG',   label: 'Sugar Log',     description: 'Daily sugar/health tracking' },
  { key: 'KITCHEN_LOG', label: 'Kitchen Diary',  description: 'Kitchen activity log' },
  { key: 'CYCLE_LOG',   label: 'Cycle Tracker',  description: 'Cycle tracking log' },
];

const ManageRoles = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Delete dialog
  const [deleteDialog, setDeleteDialog] = useState({ open: false, user: null });
  const [deleting, setDeleting] = useState(false);

  // Feature flags dialog
  const [featureDialog, setFeatureDialog] = useState({ open: false, user: null });
  const [featureFlags, setFeatureFlags] = useState({});   // { SUGAR_LOG: true, ... }
  const [featureLoading, setFeatureLoading] = useState(false);
  const [togglingKey, setTogglingKey] = useState(null);   // which chip is loading

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getAllUsers();
      setUsers(res.data);
    } catch {
      setSnackbar({ open: true, message: 'Failed to fetch users', severity: 'error' });
    }
    setLoading(false);
  };

  // ── Feature dialog ────────────────────────────────────────────────

  const openFeatureDialog = async (user) => {
    setFeatureDialog({ open: true, user });
    setFeatureLoading(true);
    setFeatureFlags({});
    try {
      const res = await getUserFeatures(user.userId);
      const flagMap = {};
      res.data.features.forEach(f => { flagMap[f.featureKey] = f.enabled; });
      setFeatureFlags(flagMap);
    } catch {
      setSnackbar({ open: true, message: 'Failed to load features', severity: 'error' });
    }
    setFeatureLoading(false);
  };

  const closeFeatureDialog = () => {
    if (togglingKey) return;   // prevent close while toggling
    setFeatureDialog({ open: false, user: null });
    setFeatureFlags({});
  };

  const handleFeatureToggle = async (featureKey, currentEnabled) => {
    const userId = featureDialog.user?.userId;
    if (!userId) return;

    setTogglingKey(featureKey);
    try {
      await updateUserFeature(userId, featureKey, !currentEnabled);
      setFeatureFlags(prev => ({ ...prev, [featureKey]: !currentEnabled }));
      setSnackbar({
        open: true,
        message: `${featureKey} ${!currentEnabled ? 'enabled' : 'disabled'}`,
        severity: 'success',
      });
    } catch {
      setSnackbar({ open: true, message: 'Failed to update feature', severity: 'error' });
    }
    setTogglingKey(null);
  };

  // ── Role / Block / Delete ─────────────────────────────────────────

  const handleRoleChange = async (email, newRole) => {
    try {
      await updateUserRole(email, newRole);
      setUsers(prev =>
        prev.map(u => u.userEmail === email ? { ...u, userRole: newRole } : u)
      );
      setSnackbar({ open: true, message: 'Role updated', severity: 'success' });
    } catch {
      setSnackbar({ open: true, message: 'Failed to update role', severity: 'error' });
    }
  };

  const handleBlockToggle = async (email, currentlyBlocked) => {
    const newStatus = !currentlyBlocked;
    try {
      await updateUserBlockStatus(email, newStatus);
      setUsers(prev =>
        prev.map(u => u.userEmail === email ? { ...u, isBlocked: newStatus } : u)
      );
      setSnackbar({
        open: true,
        message: newStatus ? 'User blocked' : 'User unblocked',
        severity: 'success',
      });
    } catch {
      setSnackbar({ open: true, message: 'Failed to update block status', severity: 'error' });
    }
  };

  const openDeleteDialog = (user) => setDeleteDialog({ open: true, user });
  const closeDeleteDialog = () => { if (!deleting) setDeleteDialog({ open: false, user: null }); };

  const handleConfirmDelete = async () => {
    const user = deleteDialog.user;
    if (!user) return;
    setDeleting(true);
    try {
      await deleteUser(user.userId);
      setUsers(prev => prev.filter(u => u.userId !== user.userId));
      setSnackbar({ open: true, message: `User "${user.userName}" deleted`, severity: 'success' });
      setDeleteDialog({ open: false, user: null });
    } catch (error) {
      setSnackbar({ open: true, message: error.response?.data?.message || 'Failed to delete user', severity: 'error' });
    } finally {
      setDeleting(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────

  return (
    <Box>
      {loading ? (
        <CircularProgress />
      ) : (
        <Paper sx={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>User ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.userId}>
                  <TableCell>{user.userId}</TableCell>
                  <TableCell>{user.userName}</TableCell>
                  <TableCell>{user.userEmail}</TableCell>
                  <TableCell>
                   <Select
  value={user.userRole}
  onChange={(e) => handleRoleChange(user.userEmail, e.target.value)}
  disabled={user.isBlocked}
  size="small"
>
  <MenuItem value="USER">User</MenuItem>
  <MenuItem value="ADMIN">Admin</MenuItem>
  <MenuItem value="DRIVER">Driver</MenuItem>
  <MenuItem value="VENDOR">Vendor</MenuItem>
</Select>
                  </TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!user.isBlocked}
                          onChange={() => handleBlockToggle(user.userEmail, !!user.isBlocked)}
                          color="error"
                          size="small"
                        />
                      }
                      label={user.isBlocked ? 'Blocked' : 'Active'}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" justifyContent="center" spacing={1}>
                      <Tooltip title="Manage Features">
                        <IconButton
                          color="primary"
                          onClick={() => openFeatureDialog(user)}
                        >
                          <TuneIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete User">
                        <IconButton
                          color="error"
                          onClick={() => openDeleteDialog(user)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {/* ── Feature Flags Dialog ───────────────────────────────────── */}
      <Dialog
        open={featureDialog.open}
        onClose={closeFeatureDialog}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>
          Feature Settings
          <Typography variant="body2" color="text.secondary">
            {featureDialog.user?.userName} — {featureDialog.user?.userEmail}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {featureLoading ? (
            <Box display="flex" justifyContent="center" py={3}>
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Stack spacing={1} mt={1}>
              {FEATURES.map(({ key, label, description }) => {
                const enabled = featureFlags[key] ?? false;
                const isToggling = togglingKey === key;
                return (
                  <Box
                    key={key}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px={1}
                    py={0.5}
                    borderRadius={1}
                    bgcolor={enabled ? 'success.50' : 'grey.50'}
                    border="1px solid"
                    borderColor={enabled ? 'success.200' : 'grey.200'}
                  >
                    <Box>
                      <Typography variant="body2" fontWeight={600}>
                        {label}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {description}
                      </Typography>
                    </Box>
                    <Switch
                      checked={enabled}
                      onChange={() => !isToggling && handleFeatureToggle(key, enabled)}
                      color="success"
                      size="small"
                      disabled={isToggling}
                    />
                  </Box>
                );
              })}
            </Stack>
          )}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={closeFeatureDialog} disabled={!!togglingKey}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete Dialog ──────────────────────────────────────────── */}
      <Dialog open={deleteDialog.open} onClose={closeDeleteDialog}>
        <DialogTitle>Delete User?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete <strong>{deleteDialog.user?.userName}</strong>{' '}
            ({deleteDialog.user?.userEmail})?
            <br /><br />
            This will permanently remove the user and all their bookings. This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog} disabled={deleting}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" disabled={deleting}>
            {deleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default ManageRoles;